<fuse-widget class="widget p-0 h-100-p" fxLayout="column">  
  <div
    class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p"
    fxLayout="column"
    fxLayoutAlign="stretch stretch"
  >
    <div
      class="px-16 py-8 border-bottom widget-header title-bar"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      set-color
      [backgroundColor]="titleBackgroundColor"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        set-color
        [backgroundColor]="titleBackgroundColor"
      >
        <div class="h3 title pr-4">{{ title }}</div>
        <div
          *ngIf="_data?.length > 0"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <div class="h3 secondary">({{ _data?.length }})</div>
        </div>
      </div>
    </div>

    <div
      *ngIf="_data?.length === 0"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxFlex
    >
      <span class="mat-h1 hint-text py-48">There are no {{ title }}</span>
    </div>

    <div *ngIf="_data.length > 0" class="processlist">
      <div
        class="p-16 clickable row list-item"
        *ngFor="let row of _data"
        (click)="select(row)"
        [ngClass]="{ selected: row?.id == _selected?.id }"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <div class="h3">{{ row.title }}</div>
              <div>
                <span class="secondary-text">{{ row.secondary }}</span>
              </div>
            </div>
          </div>
          <button
            mat-icon-button
            [style.visibility]="allowEdit === true ? 'visible' : 'hidden'"
            [matMenuTriggerFor]="moreMenu"
            aria-label="More"
            class="mat-icon-button"
            (click)="$event.stopPropagation()"
            *ngIf="allowEdit"
            matTooltip="More"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
        <mat-menu #moreMenu="matMenu">      
          <button
            mat-menu-item
            aria-label="View"
            (click)="edit(row)"
            *ngIf="!allowAdd"
          >
            <mat-icon>open_in_new</mat-icon>
            <span>View Checklist</span>
          </button>          
        </mat-menu>
      </div>
    </div>
  </div>
</fuse-widget>
